import { Injectable } from '@angular/core';
import { List } from '../constants-types/PiList.model';
import { FilterType, FilterInfo } from '../core-data-model/FilterInfo.model';
import {
    ReferencePatternType,
    ReferencePatternsInformation
} from '../core-data-model/ReferencePatternType.model';
import { UserProfileSettingsService } from '../system-services/UserProfileSettings/UserProfileSettings.service';
import { TranslationService } from '../translations';

@Injectable({
    providedIn: 'root'
})
export class TableDefinitionFactoryInit {
    ReferencePatternsInformationSorted: List<ReferencePatternType> =
        ReferencePatternsInformation.sort((a, b) => {
            const nameA = this.TR.key(a.key).toLocaleUpperCase(); // ignore upper and lowercase
            const nameB = this.TR.key(b.key).toLocaleUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }

            // names must be equal
            return 0;
        });

    constructor(
        public userProfile: UserProfileSettingsService,
        public TR: TranslationService
    ) {}

    private hasCompletedCognitiveFilter = new FilterInfo({
        type: FilterType.HasCompletedCognitive,
        showFilter: () => this.userProfile.showCognitive
    });

    private lastModifiedFilters = [
        new FilterInfo({ type: FilterType.LastSevenDaysAssessment }),
        new FilterInfo({ type: FilterType.LastThirtyDaysAssessment }),
        new FilterInfo({ type: FilterType.LastNinetyDaysAssessment })
    ];

    private peopleFilters = [
        new FilterInfo({ type: FilterType.TypeCandidate }),
        new FilterInfo({ type: FilterType.TypeEmployee }),
        new FilterInfo({ type: FilterType.TypeUnknown }),
        new FilterInfo({ type: FilterType.PeopleAdministeredByMe })
    ].concat(this.lastModifiedFilters);

    SearchFilters = [
        new FilterInfo({ type: FilterType.Jobs }),
        new FilterInfo({ type: FilterType.People })
    ]
        .concat(this.peopleFilters)
        .concat(
            this.ReferencePatternsInformationSorted.map(
                (reference: ReferencePatternType) =>
                    new FilterInfo({
                        type: FilterType.ReferenceProfile,
                        parameters: {
                            profile: reference.id,
                            key: reference.key
                        }
                    })
            ).toArray()
        );

    EmployeeDirectoryFilters = [
        new FilterInfo({ type: FilterType.HasCompletedBehavioral }),
        new FilterInfo({ type: FilterType.HasNotCompletedBehavioral })
    ]
        .concat(this.lastModifiedFilters)
        .concat(
            this.ReferencePatternsInformationSorted.map(
                (reference: ReferencePatternType) =>
                    new FilterInfo({
                        type: FilterType.ReferenceProfile,
                        parameters: {
                            profile: reference.id,
                            key: reference.key
                        }
                    })
            ).toArray()
        );

    JobsDirectoryFilters = [
        new FilterInfo({ type: FilterType.JobModifiedByMe })
    ].concat(this.lastModifiedFilters);

    PendingPageFilters = [].concat(this.peopleFilters);

    RecentlyCompletedPageFilters = [
        new FilterInfo({ type: FilterType.HasCompletedBehavioral }),
        this.hasCompletedCognitiveFilter
    ]
        .concat(this.peopleFilters)
        .concat(
            this.ReferencePatternsInformationSorted.map(
                (reference: ReferencePatternType) =>
                    new FilterInfo({
                        type: FilterType.ReferenceProfile,
                        parameters: {
                            profile: reference.id,
                            key: reference.key
                        }
                    })
            ).toArray()
        );

    JobMatchesFilters = [
        new FilterInfo({ type: FilterType.TypeCandidate }),
        new FilterInfo({ type: FilterType.ImpressionFavorite }),
        new FilterInfo({ type: FilterType.HasCompletedBehavioral }),
        this.hasCompletedCognitiveFilter
    ].concat(
        this.ReferencePatternsInformationSorted.map(
            (reference: ReferencePatternType) =>
                new FilterInfo({
                    type: FilterType.ReferenceProfile,
                    parameters: { profile: reference.id, key: reference.key }
                })
        ).toArray()
    );
}
